import { SvgIcon, type SvgIconProps } from '@mui/material';

export const GlobeIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather-icons"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />

    <line
      x1="2"
      y1="12"
      x2="22"
      y2="12"
    />

    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </SvgIcon>
);
